import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

const SAVE_BITACORA_OPERATION_CURRENCY = 'ForeignOperations';
@Component({
  selector: 'app-operation-currency',
  templateUrl: './operation-currency.component.html',
  styleUrls: ['./operation-currency.component.scss'],
})
export class OperationCurrencyComponent implements OnInit {

  formGroup: FormGroup;
  stateButton = false;
  listOperation: any = [];
  listChecked: any = [];
  isMultiproduct = false;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private captureService: CaptureService,
    private taggingService: TaggingService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
    this.isMultiproduct = this.abreCuentasService.viewOptionMultiProduct;
  }

  ngOnInit() {
    this.initValidationMulti();
    this.getData();
  }

  initValidationMulti() {
    if (this.isMultiproduct) {
      this.stateButton = true;
    }
  }

  /**
   * Summary Function to charge predefined data by attribute IsPep
   */
  getData() {
    if (this.abreCuentasService.getOperationCurrencyList() !== undefined) {
      this.listOperation = this.abreCuentasService.getOperationCurrencyList();
      this.checkStatesButton();
    } else if (this.parametersService.getSetting(OpEnum.FOREIGN_OPERATIONS_LIST) !== undefined) {
      this.listOperation = this.parametersService.getSetting(OpEnum.FOREIGN_OPERATIONS_LIST);
      this.listOperation.forEach((operation: any) => {
        operation.checked = false;
      });
    }
  }

  /**
   * Summary funcition change state checkbox
   * @param event
   */
  checkboxChange(event: any, selectedObject: any): void {
    const foreignCurrencyInfoDTO = {
      foreign_operation: selectedObject.id,
      foreign_operation_description: selectedObject.name,
    };
    if (event.checked) {
      this.listOperation.forEach((operation: any) => {
        if (operation.id === selectedObject.id) {
          operation.checked = true;
        }
      });
      this.listChecked.push(foreignCurrencyInfoDTO);
    } else {
      this.listChecked.forEach((element, index) => {
        if (element.foreign_operation === foreignCurrencyInfoDTO.foreign_operation) {
          this.listChecked.splice(index, 1);
        }
      });
      this.listOperation.forEach((operation: any) => {
        if (operation.id === selectedObject.id) {
          operation.checked = false;
        }
      });
    }
    this.checkStatesButton();
    this.abreCuentasService.setOperationCurrencyList(this.listOperation);
  }

  /**
   * Change state Button
   */
  checkStatesButton() {
    this.listChecked = [];
    this.listOperation.forEach((operation: any) => {
      const foreignCurrencyInfoDTO = {
        foreign_operation: operation.id,
        foreign_operation_description: operation.name,
      };
      if (operation.checked) {
        this.listChecked.push(foreignCurrencyInfoDTO);
      }
    });
    const tmp = this.listOperation.filter(state => {
      return state.checked === true;
    });
    if (tmp.length > 0) {
      this.stateButton = false;
    } else {
      this.stateButton = true;
    }
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.tagNextButton();
    const body = {
      foreign_currency_list: this.listChecked,
    };

    this.abreCuentasService.setOperationCurrencyList(this.listOperation);

    this.captureService.sendProspectOperationCurrency(body).then(
      (response: any) => {
        if (response.status === 200) {

          this.sendDataToBitacora();
          this.navigationService.nextStep('200');

        }
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  sendDataToBitacora() {
    if (this.isMultiproduct) {

      const bitacoraEvent = `${SAVE_BITACORA_OPERATION_CURRENCY} info_${JSON.stringify(this.listChecked)}`;

      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
  }

  tagNextButton() {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionName`].path,
          value: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionDetailsProductcategory`].value,
        },
      ];
      let foreingOperations = '';
      this.listChecked.forEach(element => {
        foreingOperations += element.foreign_operation_description + ' | ';
      });
      foreingOperations = foreingOperations.slice(0, -3);
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`] + `${foreingOperations}`,
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (err) {
      console.log(err);
    }
  }
}
